/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react'
// import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'

type Props = {
  iconPath?: string
  iconColor?: string
  title: any
  total?: string
  color?: string
  value?: any
}

const CardSystemWidgetLicenses1: React.FC<Props> = ({title, color, value}) => {
  return (
    <>
      <div
        className={`d-flex bg-hover-light-${color}  text-hover-${color}  align-items-center border border-gray-300 rounded py-2 px-3 mb-3`}
      >
        {/* begin::Icon */}
        <KTSVG path='/media/icons/duotune/art/art009.svg' className={`text-${color}  svg-icon-1`} />
        {/* end::Icon */}

        {/* begin::Title */}
        <div className='flex-grow-1'>
          <p className='fw-bold m-2 pt-1 text-stretch fs-6'>{title} </p>
        </div>
        {/* end::Title */}

        {/* begin::Lable */}
        <span className={`fw-bold fs-4 text-${color} py-1`}>{value}</span>
        {/* end::Lable */}
      </div>
    </>
  )
}

export {CardSystemWidgetLicenses1}
